import { LoadingIndicator } from "@/app/(shop)/services/[slug]/components/loadingIndicator";
import useMediaQuery from "@/utils/useMediaQuery";
import { useTranslations } from "next-intl";
import OtpInput from "react-otp-input";
import { EmailSendCodeIcon } from "../_icons/emailSendCodeIcon";
import { SendCodeIcon } from "../_icons/sendCodeIcon";
import { TextButton } from "../button/textButton";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

export const LoginModalOTPInput = ({
  setErrorMessage,
  merchantColor,
  showPhoneNumberInput,
  isLoading,
  captchaRef,
  setCode,
  getValues,
  code,
  errorMessage,
  titleId,
  subtitleId,
}: {
  // eslint-disable-next-line no-unused-vars
  setErrorMessage: (message: string | null) => void;
  errorMessage: string | null;
  merchantColor: string;
  showPhoneNumberInput: boolean;
  isLoading: boolean;
  captchaRef: any;
  // eslint-disable-next-line no-unused-vars
  // eslint-disable-next-line no-unused-vars
  setCode: (code: string) => void;
  getValues: () => { phone?: string; email?: string };
  code: string;
  titleId: string;
  subtitleId: string;
}) => {
  const t = useTranslations("LoginModalOTPInput");
  const isMobile = useMediaQuery("(max-width: 640px)");

  const otpContainerStyle = {
    width: "100%",
    paddingLeft: "0.5rem",
    paddingRight: "0.5rem",
    paddingTop: "0.75rem",
    paddingBottom: "0.75rem",
    display: "flex",
    justifyContent: "center",
    marginTop: "4rem",
    marginBottom: "4rem",
  };

  const otpInputStyle = {
    borderStyle: "solid",
    borderRadius: "0",
    fontWeight: "bold",
    fontSize: isMobile ? "2rem" : "3.5rem",
    height: "5.25rem",
    margin: "0 0.3125rem",
    padding: "0 0 2rem 0",
    width: isMobile ? "3rem" : "5.375rem",
    marginLeft: "0.3125rem",
    marginRight: "0.3125rem",
    backgroundColor: "transparent",
  };

  return (
    <div
      data-testid={applyDataTestId(pom.loginInfoModal.otpInput)}
      className="px-4 pb-4 flex flex-col justify-center items-center"
    >
      {showPhoneNumberInput && <SendCodeIcon brandingColor={merchantColor} />}
      {!showPhoneNumberInput && (
        <EmailSendCodeIcon brandingColor={merchantColor} />
      )}
      <h1
        id={titleId}
        aria-describedby={subtitleId}
        className="mt-4 text-3xl font-medium text-center text-neutral-700"
      >
        {showPhoneNumberInput
          ? t("verifyPhoneNumber")
          : t("verifyEmailAddress")}
      </h1>
      <p
        id={subtitleId}
        className="mt-5 text-base leading-6 text-center text-[15px] text-neutral-700 sm:w-[460px]"
      >
        {t("otpMessage", {
          userAddress: showPhoneNumberInput
            ? getValues().phone || ""
            : getValues().email || "",
        })}
      </p>
      <div className="">
        {isLoading && <LoadingIndicator />}
        {!isLoading && (
          <OtpInput
            numInputs={6}
            value={code}
            onChange={setCode}
            containerStyle={otpContainerStyle}
            inputStyle={otpInputStyle}
            inputType="number"
            renderInput={(props) => (
              <input
                aria-labelledby={`${titleId} ${subtitleId}`}
                name="otp"
                {...props}
                onFocus={(e) => {
                  props.onFocus?.(e);
                  e.target.style.setProperty("--merchant-color", merchantColor);
                }}
                style={{
                  ...props.style,
                  outline: "none",
                }}
                className={`border-b-4 border-b-[#C7C7C7] focus:border-b-[var(--merchant-color)]`}
              />
            )}
            shouldAutoFocus={true}
          />
        )}
      </div>
      {errorMessage && code.length === 6 && (
        <div className="text-red-600 text-sm mt-2">{errorMessage}</div>
      )}
      <TextButton
        style={{ color: merchantColor }}
        className={`fixed bottom-0 border sm:border-none rounded-none border-[#e5e5e5] sm:static mt-8 sm:mb-6 text-[15px] sm:text-xl font-medium leading-7 text-center text-[#228800] max-md:mt-10 ${
          isMobile && "w-full h-16"
        }`}
        onClick={() => {
          setCode("");
          setErrorMessage(null);
          captchaRef.current?.reset();
          captchaRef.current?.execute();
        }}
      >
        {t("resendCode")}
      </TextButton>
    </div>
  );
};
